import DOMPurify from 'dompurify';

export function sanitize(text: string): string {
  return DOMPurify.sanitize(text);
}
